import { useFormField } from '@calendly/form'
import { getTimezoneName } from '@calendly/timezone-tools'
import { BodyText } from '@calendly/ui/components/typography'

import { TimezoneDropdown as BareTimezoneDropdown } from 'components/event_type_edit'

export const TimezoneDropdown = ({ isManaged = false, formPath, readOnly, expandLeft, fixTimezonePositioning = false }) => {
  const [{ value: timezone }, _, { setValue }] = useFormField({ name: `${formPath}.timezone` })
  const [___, __, { setValue: setUsingCustomHours }] = useFormField({ name: `${formPath}.usingCustomHours` })
  const [____, _____, { setValue: setUsingSecondarySchedule }] = useFormField({ name: `${formPath}.usingSecondarySchedule` })

  const onChange = (value) => {
    setValue(value)
    setUsingCustomHours(true)
    setUsingSecondarySchedule(false)
  }

  if (readOnly) { return <BodyText size="x-small">{getTimezoneName(timezone)}</BodyText> }

  return (
    <BareTimezoneDropdown
      timezone={timezone}
      onSelectTimezone={onChange}
      isManaged={isManaged}
      expandLeft={expandLeft}
      shiftLeft15
      shiftLeft24={fixTimezonePositioning}
      noIcon
    />
  )
}
